import { FC, useEffect } from 'react';
import useTrainingJumpSentence from '../../hooks/useTrainingJumpSentence';
import VisibilitySpan from '../Atoms/VisibilitySpan';

type JumpSentence = {
  // テキスト
  text: string;
  // 終了時間
  endTime: number;
};

type Props = {
  // 現在の再生時間
  currentTime: number;
  // 英語のセンテンス
  englishSentence: JumpSentence;
  // 最初のセンテンスの開始時間
  firstSentenceStartTime: number;
  // トピックのセンテンスかどうか
  isTopic: boolean;
};

const TrainingJumpSentence: FC<Props> = ({
  currentTime,
  englishSentence,
  firstSentenceStartTime,
  isTopic,
}) => {
  const { isVisible, updateIsVisible } = useTrainingJumpSentence(
    firstSentenceStartTime,
    englishSentence.endTime,
  );

  // currentTimeが変更されたら、表示/非表示を切り替える
  useEffect(() => {
    updateIsVisible(currentTime);
  }, [updateIsVisible, currentTime]);

  const sentenceElement = () => {
    if (isTopic) {
      return (
        <>
          <VisibilitySpan isVisible={isVisible} text={englishSentence.text} />
          <br />
        </>
      );
    }

    const endSpaceText = `${englishSentence.text} `;

    return <VisibilitySpan isVisible={isVisible} text={endSpaceText} />;
  };

  return sentenceElement();
};

export default TrainingJumpSentence;
